export const API_ENDPOINTS = {
  // Auth — Gateway /login/* → Auth Service :5000
  AUTH: {
    LOGIN: '/login/login',
    ADMIN_LOGIN: '/login/admin/login',   // ← this
    VENDOR_LOGIN: '/login/vendor-referee/login',
    LOGOUT: '/login/logout',
    REFRESH: '/login/refresh-token',
    FORGOT_PASSWORD: '/login/forgot-password',
    CHANGE_PASSWORD: '/login/me/change-password',
    RESET_PASSWORD: '/login/reset-password',
    REGISTER: '/login/register',
    APPROVE_USER: (userId) => `/login/approve/${userId}`,
    GET_USERS: '/login/users',
  },

  // Dashboard
  DASHBOARD: {
    STATS: '/dashboard/stats',
    USER_DISTRIBUTION: '/dashboard/user-distribution',
    REVENUE_BREAKDOWN: '/dashboard/revenue-breakdown',
    TOURNAMENT_STATUS: '/dashboard/tournament-status',
  },

  // Vendors — Gateway /vendors/* → Vendor Service :5001
  VENDORS: {
    LIST: '/vendors',
    CREATE: '/vendors',
    REGISTER: '/vendors/register',
    SEND_OTP: '/vendors/send-otp',
    VERIFY_OTP: '/vendors/verify-otp',
    GET_BY_ID: (id) => `/vendors/${id}`,
    UPDATE: (id) => `/vendors/${id}`,
    DELETE: (id) => `/vendors/${id}`,
    STATUS: (id) => `/vendors/${id}/status`,
    APPROVAL: (id) => `/vendors/${id}/approval`,
    VERIFY_BANK: (id) => `/vendors/${id}/verify-bank`,
    ME: '/vendors/me',
    ME_DISABLE: '/vendors/me/disable',
  },


  // TOURNAMENTS: {
  //     BASE: '/tournaments',
  //     BY_ID: (id) => `/tournaments/${id}`,
  //     TOGGLE: (id) => `/tournaments/${id}/toggle`,
  //      APPROVE: (id) => `/tournaments/${id}/approve`,   // ADD
  //     REJECT: (id) => `/tournaments/${id}/reject`, 
  //     STATS: '/tournaments/stats',
  //     VENDOR_COURTS: (vendorId) => `/tournaments/vendors/${vendorId}/courts`,


  //   },

  //   REGISTRATIONS: {
  //     BASE: '/tournaments/registrations',
  //     BY_ID: (id) => `/tournaments/registrations/${id}`,
  //     STATUS: (id) => `/tournaments/registrations/${id}/status`,
  //     APPROVE: (id) => `/tournaments/registrations/${id}/approve`,
  //     REJECT: (id) => `/tournaments/registrations/${id}/reject`,
  //   },

  //   MATCHES: {
  //     BASE: '/tournaments/matches',
  //     BY_ID: (id) => `/tournaments/matches/${id}`,
  //   },

  //   VENDOR: {
  //     TOURNAMENTS: {
  //       BASE: '/tournaments/vendor',
  //       BY_ID: (id) => `/tournaments/vendor/${id}`,
  //       TOGGLE: (id) => `/tournaments/vendor/${id}/toggle`,
  //       STATS: '/tournaments/vendor/stats',
  //       MY_COURTS: '/tournaments/vendor/courts',
  //     },

  //     REGISTRATIONS: {
  //       BASE: '/tournaments/vendor/registrations',
  //       BY_ID: (id) => `/tournaments/vendor/registrations/${id}`,
  //       STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
  //     },

  //     MATCHES: {
  //       BASE: '/tournaments/vendor/matches',
  //       BY_ID: (id) => `/tournaments/vendor/matches/${id}`,
  //     },
  //   },
  TOURNAMENTS: {
    BASE: '/tournaments',
    BY_ID: (id) => `/tournaments/${id}`,
    TOGGLE: (id) => `/tournaments/${id}/toggle`,
    APPROVE: (id) => `/tournaments/${id}/approve`,
    REJECT: (id) => `/tournaments/${id}/reject`,
    STATS: '/tournaments/stats',
    VENDOR_COURTS: (vendorId) => `/tournaments/vendors/${vendorId}/courts`,

    // ADD — admin verifies a customer tournament's bank details via Surepass
    VERIFY_BANK: (id) => `/tournaments/customer/${id}/verify-bank`,

    // ADD — customer's own tournaments
    CUSTOMER: {
      BASE: '/tournaments/customer',
      BY_ID: (id) => `/tournaments/customer/${id}`,
      TOGGLE: (id) => `/tournaments/customer/${id}/toggle`,
    },
  },

  REGISTRATIONS: {
    BASE: '/tournaments/registrations',
    BY_ID: (id) => `/tournaments/registrations/${id}`,
    STATUS: (id) => `/tournaments/registrations/${id}/status`,
    APPROVE: (id) => `/tournaments/registrations/${id}/approve`,
    REJECT: (id) => `/tournaments/registrations/${id}/reject`,
  },

  MATCHES: {
    BASE: '/tournaments/matches',
    BY_ID: (id) => `/tournaments/matches/${id}`,
    REFEREE_PAYMENT: (id) => `/tournaments/matches/${id}/referee-payment`, 
  },

  VENDOR: {
    TOURNAMENTS: {
      BASE: '/tournaments/vendor',
      BY_ID: (id) => `/tournaments/vendor/${id}`,
      TOGGLE: (id) => `/tournaments/vendor/${id}/toggle`,
      STATS: '/tournaments/vendor/stats',
      MY_COURTS: '/tournaments/vendor/courts',
    },

    REGISTRATIONS: {
      BASE: '/tournaments/vendor/registrations',
      BY_ID: (id) => `/tournaments/vendor/registrations/${id}`,
      STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
    },

    MATCHES: {
      BASE: '/tournaments/vendor/matches',
      BY_ID: (id) => `/tournaments/vendor/matches/${id}`,
      REFEREE_PAYMENT: (id) => `/tournaments/vendor/matches/${id}/referee-payment`,
    },
  },


  COACHES: {
    // ─── Public ───────────────────────────────────────────────────────────────
    LIST: '/coaches',
    GET: (id) => `/coaches/${id}`,
    SLOTS: (id) => `/coaches/${id}/slots`,        // single-day public slots
    PUBLIC_REGISTER: '/coaches/public/register',
    PUBLIC_VENDORS: '/coaches/public/vendors',
    PUBLIC_COURTS_BY_VENDOR: (vendorId) => `/coaches/public/vendors/${vendorId}/courts`,

    SEND_OTP: '/vendors/send-otp',
    VERIFY_OTP: '/vendors/verify-otp',

    MY_PROFILE: '/coaches/me/profile',               // GET + PUT (self edit)
    MY_PROFILE_SLOTS_WEEKLY: '/coaches/me/profile/slots/weekly',
    MY_PROFILE_TOGGLE_STATUS: '/coaches/me/profile/status',
    MY_PROFILE_DELETE_CERTIFICATE: (certId) => `/coaches/me/profile/certificates/${certId}`, // ✅ NEW

    // ─── Vendor ───────────────────────────────────────────────────────────────
    MY_COACHES: '/coaches/my',
    VENDOR_REGISTRATION: (id) => `/coaches/my/${id}/registration`,
    CREATE: '/coaches',
    UPDATE_MY: (id) => `/coaches/my/${id}`,
    DELETE_MY: (id) => `/coaches/my/${id}`,
    TOGGLE_STATUS: (id) => `/coaches/my/${id}/status`,
    MY_SLOTS_WEEKLY: (id) => `/coaches/my/${id}/slots/weekly`,
    MY_COURTS: '/coaches/my/courts',
    VENDOR_APPROVE_COACH: (id) => `/coaches/my/${id}/approve`,   // ✅ NEW
    VENDOR_REJECT_COACH: (id) => `/coaches/my/${id}/reject`,    // ✅ NEW
    DELETE_COACH_CERTIFICATE: (id, certId) => `/coaches/my/${id}/certificates/${certId}`, // ✅ NEW
    // ─── Admin ────────────────────────────────────────────────────────────────
    ADMIN_ALL: '/coaches/admin/all',
    ADMIN_VENDORS: '/coaches/admin/vendors',
    ADMIN_DELETE: (id) => `/coaches/admin/${id}`,
    ADMIN_COURTS_BY_VENDOR: (vendorId) => `/coaches/admin/vendors/${vendorId}/courts`,
    ADMIN_REGISTRATION: (id) => `/coaches/admin/${id}/registration`,
    ADMIN_UPDATE: (id) => `/coaches/admin/${id}`,
    ADMIN_TOGGLE_STATUS: (id) => `/coaches/admin/${id}/status`,
    ADMIN_SLOTS_WEEKLY: (id) => `/coaches/admin/${id}/slots/weekly`,
    ADMIN_APPROVE_COACH: (id) => `/coaches/admin/${id}/approve`, // ✅ NEW
    ADMIN_REJECT_COACH: (id) => `/coaches/admin/${id}/reject`, // ✅ NEW
    ADMIN_BANK_VERIFY: (id) => `/coaches/admin/${id}/bank-verify`,
  },

  COURTS: {
    // ── Public: Facility ────────────────────────────────────────────────────
    LIST: '/courts',
    GET_BY_ID: (id) => `/courts/${id}`,

    // ── Vendor / Admin: Facility ─────────────────────────────────────────────
    MY_COURTS: '/courts/my',
    CREATE: '/courts',
    UPDATE: (id) => `/courts/my/${id}`,
    DELETE: (id) => `/courts/my/${id}`,
    TOGGLE_STATUS: (id) => `/courts/my/${id}/status`,
    REGISTRATIONS: (id) => `/courts/${id}/registrations`,

    // ── Admin Override ───────────────────────────────────────────────────────
    ADMIN_STATUS: (id) => `/courts/${id}/status`,

    // ── Dropdowns ────────────────────────────────────────────────────────────
    DROPDOWN_SPORTS: '/courts/dropdown/sports',
    DROPDOWN_VENDORS: '/courts/dropdown/vendors',

    // ── Public: Grounds (browse for booking) ─────────────────────────────────
    // NOTE: pass { date: 'YYYY-MM-DD' } as a filter/param on these two to get
    // date-aware slots (peak pricing baked into each slot's `price`/`isPeak`,
    // closed/overridden dates reflected, and food/accessories blacked out
    // per any CourtDateOverride for that date) — no separate endpoint needed.
    GROUNDS_PUBLIC: (courtId) => `/courts/${courtId}/grounds/public`,
    GROUND_SLOTS_PUBLIC: (courtId, groundId) => `/courts/${courtId}/grounds/${groundId}/slots/public`,

    // ── Vendor / Admin: Grounds (CRUD under a facility) ───────────────────────
    // NOTE: peak-hour rules are just a `peakHours[]` field on the ground now —
    // set them via GROUND_CREATE / GROUND_UPDATE, no separate endpoint.
    GROUNDS_LIST: (courtId) => `/courts/my/${courtId}/grounds`,
    GROUND_CREATE: (courtId) => `/courts/my/${courtId}/grounds`,
    GROUND_GET: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}`,
    GROUND_UPDATE: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}`,
    GROUND_DELETE: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}`,
    GROUND_TOGGLE_STATUS: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}/status`,

    // ── Vendor / Admin: Ground Slots ───────────────────────────────────────────
    GROUND_SLOTS: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}/slots`,

    // ── Vendor / Admin: Ground-level date overrides (close a date / swap that date's slots) ──
    GROUND_DATE_OVERRIDE_UPSERT: (courtId, groundId) => `/courts/my/${courtId}/grounds/${groundId}/date-overrides`,
    GROUND_DATE_OVERRIDE_GET: (courtId, groundId, date) => `/courts/my/${courtId}/grounds/${groundId}/date-overrides/${date}`,
    GROUND_DATE_OVERRIDE_DELETE: (courtId, groundId, date) => `/courts/my/${courtId}/grounds/${groundId}/date-overrides/${date}`,

    // ── Vendor / Admin: Court-level date overrides (food/accessory blackout for a date) ──
    COURT_DATE_OVERRIDE_UPSERT: (courtId) => `/courts/my/${courtId}/date-overrides`,
    COURT_DATE_OVERRIDE_GET: (courtId, date) => `/courts/my/${courtId}/date-overrides/${date}`,
    COURT_DATE_OVERRIDE_DELETE: (courtId, date) => `/courts/my/${courtId}/date-overrides/${date}`,

    // ── Booking ────────────────────────────────────────────────────────────────
    GROUND_BOOK_SLOT: (courtId, groundId, day, slotId) =>
      `/courts/${courtId}/grounds/${groundId}/slots/${day}/${slotId}/book`,
    GROUND_UNBOOK_SLOT: (courtId, groundId, day, slotId) =>
      `/courts/${courtId}/grounds/${groundId}/slots/${day}/${slotId}/unbook`,


    // ── Memberships ─────────────────────────────────────────────────────────
    MEMBERSHIPS_PUBLIC: (courtId) => `/courts/${courtId}/memberships/public`,
    MEMBERSHIPS_LIST: (courtId) => `/courts/my/${courtId}/memberships`,
    MEMBERSHIP_CREATE: (courtId) => `/courts/my/${courtId}/memberships`,
    MEMBERSHIP_GET: (courtId, membershipId) => `/courts/my/${courtId}/memberships/${membershipId}`,
    MEMBERSHIP_UPDATE: (courtId, membershipId) => `/courts/my/${courtId}/memberships/${membershipId}`,
    MEMBERSHIP_DELETE: (courtId, membershipId) => `/courts/my/${courtId}/memberships/${membershipId}`,
    MEMBERSHIP_TOGGLE_STATUS: (courtId, membershipId) => `/courts/my/${courtId}/memberships/${membershipId}/status`,
  },
  //  PLAYERS: {
  // // Public
  //   LIST: '/players',
  //   GET: (id) => `/players/${id}`,
  //   SLOTS: (id) => `/players/${id}/slots`,

  //   // Vendor
  //   MY_PLAYERS: '/players/my',
  //   VENDOR_REGISTRATION: (id) => `/players/my/${id}/registration`,
  //   CREATE: '/players',
  //   UPDATE_MY: (id) => `/players/my/${id}`,
  //   DELETE_MY: (id) => `/players/my/${id}`,
  //   TOGGLE_MY_STATUS: (id) => `/players/my/${id}/status`,
  //   MY_SLOTS_WEEKLY: (id) => `/players/my/${id}/slots/weekly`,
  //   MY_COURTS: '/players/my/courts',

  //   // Slot booking
  //   BOOK_SLOT: (playerId, day, slotId) =>
  //       `/players/${playerId}/slots/${day}/${slotId}/book`,
  //   UNBOOK_SLOT: (playerId, day, slotId) =>
  //       `/players/${playerId}/slots/${day}/${slotId}/unbook`,

  //   // Admin
  //   ADMIN_ALL: '/players/admin/all',
  //   ADMIN_VENDORS: '/players/admin/vendors',
  //   ADMIN_COURTS_BY_VENDOR: (vendorId) =>
  //       `/players/admin/vendors/${vendorId}/courts`,
  //   ADMIN_REGISTRATION: (id) => `/players/admin/${id}/registration`,
  //   ADMIN_TOGGLE_STATUS: (id) => `/players/admin/${id}/status`,
  //   ADMIN_UPDATE: (id) => `/players/admin/${id}`,
  //   ADMIN_DELETE: (id) => `/players/admin/${id}`,
  //   ADMIN_SLOTS_WEEKLY: (id) => `/players/admin/${id}/slots/weekly`,
  //   },
  PLAYERS: {
    LIST: '/players',
    GET: (id) => `/players/${id}`,
    SLOTS: (id) => `/players/${id}/slots`,

    SEND_OTP: '/vendors/send-otp',
    VERIFY_OTP: '/vendors/verify-otp',

    SELF_PROFILE: '/players/self',
    SELF_UPDATE: '/players/self',
    SELF_WEEKLY_SLOTS: '/players/self/slots/weekly',
    SELF_STATUS: '/players/self/status',
    SELF_DELETE_CERTIFICATE: (certId) => `/players/self/certificates/${certId}`, // ✅ NEW

    CREATE: '/players',
    PUBLIC_REGISTER: '/players/public/register',
    MY_PLAYERS: '/players/my',
    VENDOR_REGISTRATION: (id) => `/players/my/${id}/registration`,
    VENDOR_UPDATE: (id) => `/players/my/${id}`,
    VENDOR_STATUS: (id) => `/players/my/${id}/status`,
    VENDOR_DELETE: (id) => `/players/my/${id}`,
    VENDOR_WEEKLY_SLOTS: (id) => `/players/my/${id}/slots/weekly`,
    VENDOR_APPROVE: (id) => `/players/my/${id}/approve`,       // ✅ NEW
    VENDOR_REJECT: (id) => `/players/my/${id}/reject`,         // ✅ NEW
    VENDOR_DELETE_CERTIFICATE: (id, certId) => `/players/my/${id}/certificates/${certId}`, // ✅ NEW
    MY_COURTS: '/players/my/courts',
    VENDOR_VERIFY_BANK: (id) => `/players/my/${id}/verify-bank`,

    ADMIN_ALL: '/players/admin/all',
    ADMIN_REGISTRATION: (id) => `/players/admin/${id}/registration`,
    ADMIN_UPDATE: (id) => `/players/admin/${id}`,
    ADMIN_STATUS: (id) => `/players/admin/${id}/status`,
    ADMIN_DELETE: (id) => `/players/admin/${id}`,
    ADMIN_WEEKLY_SLOTS: (id) => `/players/admin/${id}/slots/weekly`,
    ADMIN_VENDORS: '/players/admin/vendors',
    ADMIN_COURTS_BY_VENDOR: (vendorId) => `/players/admin/vendors/${vendorId}/courts`,
    ADMIN_APPROVE: (id) => `/players/admin/${id}/approve`,     // ✅ NEW
    ADMIN_REJECT: (id) => `/players/admin/${id}/reject`,       // ✅ NEW
    ADMIN_DELETE_CERTIFICATE: (id, certId) => `/players/admin/${id}/certificates/${certId}`, // ✅ NEW
    ADMIN_VERIFY_BANK: (id) => `/players/admin/${id}/verify-bank`, // ✅ NEW

    BOOK_SLOT: (id, day, slotId) => `/players/${id}/slots/${day}/${slotId}/book`,
    UNBOOK_SLOT: (id, day, slotId) => `/players/${id}/slots/${day}/${slotId}/unbook`,
  },


  SPORTS: {
    LIST: '/sports',
    LIST_ALL: '/sports/all',
    CREATE: '/sports',
    GET_BY_ID: (id) => `/sports/${id}`,
    UPDATE: (id) => `/sports/${id}`,
    DELETE: (id) => `/sports/${id}`,
    TOGGLE_STATUS: (id) => `/sports/${id}/status`,   // ← add this
  },

  // Payments
  PAYMENTS: {
    LIST: '/payments',
    STATS: '/payments/stats',
    REFUND: (id) => `/payments/${id}/refund`,
    REVENUE_BY_ADMIN: '/payments/revenue-by-admin',
  },

    // Referees
    // REFEREE: {
    //     BASE: '/referees',
    //     BY_ID: (id) => `/referees/${id}`,
    //     STATUS: (id) => `/referees/${id}/status`,
    //     MATCHES: (id) => `/referees/${id}/matches`,
    //     SPORTS: '/referees/sports',
    //     TOURNAMENTS: '/referees/tournaments',
    // },
    //  REFEREE: {
  // Referees
  // REFEREE: {
  //     BASE: '/referees',
  //     BY_ID: (id) => `/referees/${id}`,
  //     STATUS: (id) => `/referees/${id}/status`,
  //     MATCHES: (id) => `/referees/${id}/matches`,
  //     SPORTS: '/referees/sports',
  //     TOURNAMENTS: '/referees/tournaments',
  // },
  REFEREE: {
    BASE: '/referees',
    REGISTER: '/referees/register',
    ME: '/referees/me',
    ME_STATUS: '/referees/me/status',
    BY_ID: (id) => `/referees/${id}`,
    STATUS: (id) => `/referees/${id}/status`,
    APPROVE: (id) => `/referees/${id}/approve`,   // ← ADD
    REJECT: (id) => `/referees/${id}/reject`,     // ← ADD
    VERIFY_BANK: (id) => `/referees/${id}/verify-bank`, // ← ADD
    MATCHES: (id) => `/referees/${id}/assigned-matches`,
    SPORTS: '/referees/sports/active',
    TOURNAMENTS_ASSIGNABLE: '/referees/tournaments/assignable',
    BY_TOURNAMENT: (tournamentId) => `/referees/tournament/${tournamentId}`,
    DELETE: (id) => `/referees/${id}`,
  },
  COMMISSION: {
    GET_ALL: '/commissions',
    UPDATE_SINGLE: '/commissions/single',
    UPDATE_BULK: '/commissions/bulk',
    RESET_DEFAULTS: '/commissions/reset-defaults',
  },
  REWARDS: {
    COUPONS: '/rewards/coupons',
    COUPON_BY_ID: (id) => `/rewards/coupons/${id}`,
    COUPON_TOGGLE: (id) => `/rewards/coupons/${id}/toggle`,
    COUPON_STATS: '/rewards/stats/coupons',

    REDEEM_OPTIONS: '/rewards/redeem-options',
    REDEEM_OPTION_BY_ID: (id) => `/rewards/redeem-options/${id}`,
    REDEEM_OPTION_TOGGLE: (id) => `/rewards/redeem-options/${id}/toggle`,
    REDEEM_STATS: '/rewards/stats/redeem-options',

    POINTS_HISTORY: '/rewards/points-history',
    POINTS_STATS: '/rewards/stats/points',
  },
  // AI_COACH: {
  //   PLANS: '/ai-coach',
  //   PLAN_BY_ID: (id) => `/ai-coach/${id}`,
  //   PLAN_TOGGLE: (id) => `/ai-coach/${id}/toggle`,
  //   PLAN_STATS: '/ai-coach/stats/overview',

  //   ORDERS: '/ai-coach',
  //   ORDER_BY_ID: (id) => `/ai-coach/${id}`,
  //   ORDER_SUBSCRIBERS_BY_PLAN: (planId) => `/ai-coach/${planId}/subscribers`,
  // },
  AI_COACH: {
    PLANS: '/ai-coach/plans',
    PLAN_BY_ID: (id) => `/ai-coach/plans/${id}`,
    PLAN_TOGGLE: (id) => `/ai-coach/plans/${id}/toggle`,
    PLAN_STATS: '/ai-coach/plans/stats/overview',

    ORDERS: '/ai-coach/orders',
    ORDER_BY_ID: (id) => `/ai-coach/orders/${id}`,
    MY_ORDERS: '/ai-coach/orders/me',
    BUY_PLAN: '/ai-coach/orders/buy',
    ORDER_SUBSCRIBERS_BY_PLAN: (planId) => `/ai-coach/orders/plan/${planId}/subscribers`,
  },
  ROLES: {
    GET_ALL: '/roles/roles',            // GET    /roles/roles
    GET_ACTIVE: '/roles/roles/active',     // GET    /roles/roles/active
    GET_BY_ID: (id) => `/roles/roles/${id}`,          // GET    /roles/roles/:id
    CREATE: '/roles/roles',            // POST   /roles/roles
    UPDATE: (id) => `/roles/roles/${id}`,          // PATCH  /roles/roles/:id
    DELETE: (id) => `/roles/roles/${id}`,          // DELETE /roles/roles/:id

    GET_PERMISSIONS: (id) => `/roles/roles/${id}/permissions`,  // GET /roles/roles/:id/permissions
    SAVE_PERMISSIONS: (id) => `/roles/roles/${id}/permissions`,  // PUT /roles/roles/:id/permissions
  },

  PERMISSIONS: {
    MODULES: '/roles/permissions/modules',  // GET /roles/permissions/modules
  },

  USERS: {
    GET_ALL: '/roles/users',                // GET    /roles/users
    GET_BY_ID: (id) => `/roles/users/${id}`,              // GET    /roles/users/:id
    CREATE: '/roles/users',                // POST   /roles/users (form-data)
    UPDATE: (id) => `/roles/users/${id}`,              // PATCH  /roles/users/:id
    CHANGE_PASSWORD: (id) => `/roles/users/${id}/password`,     // PATCH  /roles/users/:id/password
    DELETE_PHOTO: (id) => `/roles/users/${id}/photo`,        // DELETE /roles/users/:id/photo
    DELETE: (id) => `/roles/users/${id}`,              // DELETE /roles/users/:id
  },
  FEEDBACKS: {
    // Customer
    SUBMIT: (type) => `/feedbacks/feedbacks/${type}`,

    // Vendor — my feedbacks (JWT-scoped, no vendorId needed in URL)
    MY_FEEDBACKS: (type) => `/feedbacks/feedbacks/${type}/vendor/my`,

    // Vendor / Admin — feedbacks for a specific entity
    BY_ENTITY: (type, entityId) => `/feedbacks/feedbacks/${type}/entity/${entityId}`,

    // Admin — feedbacks for a specific vendorId
    BY_VENDOR: (type, vendorId) => `/feedbacks/feedbacks/${type}/vendor/${vendorId}`,

    MY_ENTITY_FEEDBACKS: (type) => `/feedbacks/feedbacks/${type}/my`,

    // Admin — all feedbacks across all 4 types
    ADMIN_ALL: '/feedbacks/admin/all',

    // Admin — stats
    ADMIN_STATS: '/feedbacks/admin/stats',

    // Vendor / Admin — delete a feedback
    DELETE: (type, id) => `/feedbacks/feedbacks/${type}/${id}`,
  },
  // BOOKINGS: {

  //   // ─── POST ─────────────────────────────────────────────────────────────────
  //   CREATE_COURT  : '/bookings/court',
  //   CREATE_COACH  : '/bookings/coach',
  //   CREATE_PLAYER : '/bookings/player',

  //   // ─── GET /bookings/:bookingId ─────────────────────────────────────────────
  //   GET: (bookingId) => `/bookings/${bookingId}`,

  //   // ─── GET /bookings/vendor/:vendorId  (?type=court|coach|player) ──────────
  //   BY_VENDOR: (vendorId) => `/bookings/vendor/${vendorId}`,

  //   // ─── GET /bookings/entity/:type/:entityId ─────────────────────────────────
  //   BY_ENTITY: (type, entityId) => `/bookings/entity/${type}/${entityId}`,

  //   // ─── PATCH /bookings/:bookingId/cancel ────────────────────────────────────
  //   CANCEL: (bookingId) => `/bookings/${bookingId}/cancel`,
  // },
  BOOKINGS: {
    CREATE_COURT: '/bookings/court',
    CREATE_COACH: '/bookings/coach',
    CREATE_PLAYER: '/bookings/player',

    GET: (bookingId) => `/bookings/${bookingId}`,

    MY_BOOKINGS: '/bookings/my-bookings',

    CUSTOMER_MY_BOOKINGS: '/bookings/customer/my-bookings',   // <-- add
    COACH_MY_BOOKINGS: '/bookings/coach/my-bookings',         // <-- add
    PLAYER_MY_BOOKINGS: '/bookings/player/my-bookings',

    BY_VENDOR: (vendorId) => `/bookings/vendor/${vendorId}`,

    BY_ENTITY: (type, entityId) => `/bookings/entity/${type}/${entityId}`,

    CANCEL: (bookingId) => `/bookings/${bookingId}/cancel`,
    CUSTOMER_STATS: '/bookings/admin/customer-stats',
  },
  // TOURNAMENT_REGISTRATIONS: {
  //   CREATE: '/tournamentregistrations/',
  //   MY_REGISTRATIONS: '/tournamentregistrations/me',
  //   GET: (registrationId) => `/tournamentregistrations/${registrationId}`,
  //   BY_TOURNAMENT: (tournamentId) => `/tournamentregistrations/tournament/${tournamentId}`,
  //   CANCEL: (registrationId) => `/tournamentregistrations/${registrationId}/cancel`,
  // },
  TOURNAMENT_REGISTRATIONS: {
    CREATE: '/tournamentregistrations/',
    MY_REGISTRATIONS: '/tournamentregistrations/me',
    GET: (registrationId) => `/tournamentregistrations/${registrationId}`,
    BY_TOURNAMENT: (tournamentId) => `/tournamentregistrations/tournament/${tournamentId}`,
    CANCEL: (registrationId) => `/tournamentregistrations/${registrationId}/cancel`,
    BY_USER_ID: (userId) => `/tournamentregistrations/user/${userId}`,
    USER_STATS: '/tournamentregistrations/stats/users',
  },
  //   MONTHLY_PLAN_BOOKINGS: {
  //   CREATE: '/monthly-bookings/monthly-plan-bookings',
  //   MY_BOOKINGS: '/monthly-bookings/monthly-plan-bookings/me',
  //   GET: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}`,
  //   CANCEL: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}/cancel`,
  //   ADMIN_LIST: '/monthly-bookings/monthly-plan-bookings',
  // },
  MONTHLY_PLAN_BOOKINGS: {
    CREATE: '/monthly-bookings/monthly-plan-bookings',
    MY_BOOKINGS: '/monthly-bookings/monthly-plan-bookings/me',
    GET: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}`,
    CANCEL: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}/cancel`,
    COACH: (coachId) => `/monthly-bookings/monthly-plan-bookings/coach/${coachId}`,
    ADMIN_LIST: '/monthly-bookings/monthly-plan-bookings',
  },
  PERFORMANCE_REVIEWS: {
    CREATE: '/performance-reviews',
    GET_BY_ID: (reviewId) => `/performance-reviews/${reviewId}`,
    GET_BY_BOOKING: (bookingId) => `/performance-reviews/booking/${bookingId}`,
    GET_BY_COACH: (coachId) => `/performance-reviews/coach/${coachId}`,
    GET_BY_STUDENT: (studentId) => `/performance-reviews/student/${studentId}`,
    UPDATE: (reviewId) => `/performance-reviews/${reviewId}`,
    DELETE: (reviewId) => `/performance-reviews/${reviewId}`,
  },
  MEMBERSHIPS: {
    BUY: '/memberships/buy',
    MY: '/memberships/my',
    GET_ONE: (id) => `/memberships/${id}`,

    ADMIN_ALL: '/memberships/admin/all',

    VENDOR_ALL: '/memberships/vendor/all',
  },

  // ─── In-App (Bell Icon) Notifications ────────────────────────────────────────
  IN_APP_NOTIFICATIONS: {
    LIST: '/in-app-notifications',
    COUNT: '/in-app-notifications/count',
    MARK_READ: (id) => `/in-app-notifications/${id}/read`,
    MARK_ALL_READ: '/in-app-notifications/read-all',
    MARK_ALL: '/in-app-notifications/read-all',
    DELETE: (id) => `/in-app-notifications/${id}`,
  },

  SCORING: {
    START: '/live-score/start',
    SYNC: '/live-score/sync',
    BY_MATCH: (matchId) => `/live-score/${matchId}`,
    EVENTS: (matchId) => `/live-score/${matchId}/events`,
    ADD_EVENT: (matchId) => `/live-score/${matchId}/events`,
    UNDO: (matchId) => `/live-score/${matchId}/undo`,
    PAUSE: (matchId) => `/live-score/${matchId}/pause`,
    RESUME: (matchId) => `/live-score/${matchId}/resume`,
    END: (matchId) => `/live-score/${matchId}/end`,
  },

  SUPPORT: {
    CREATE_TICKET: '/tickets',
    MY_TICKETS: '/tickets/mine',
    INCOMING_TICKETS: '/tickets/incoming',
    TICKET_BY_ID: (ticketId) => `/tickets/${ticketId}`,
    UPDATE_STATUS: (ticketId) => `/tickets/${ticketId}/status`,
    ASSIGN_TO_ME: (ticketId) => `/tickets/${ticketId}/assign`,
    SEND_MESSAGE: (ticketId) => `/tickets/${ticketId}/messages`,
    GET_MESSAGES: (ticketId) => `/tickets/${ticketId}/messages`,
  },
};